<template>
    <div class="check__item">
        <input
            type="radio"
            :name="listData.group"
            :value="listData.value"
            :disabled="listData.disabled"
            class="checkMark"
            @input="$emit('listTarget', $event.target.value)"
            :id="`checkMark-${listData.group}-${listData.id}`"
        />
        <label
            class="listText"
            :for="`checkMark-${listData.group}-${listData.id}`"
            >{{ listData.listTitle }}</label
        >
        <label
            class="point"
            :for="`checkMark-${listData.group}-${listData.id}`"
        ></label>
    </div>
</template>

<script>
export default {
    name: "FormList",
    emits: ["listTarget"],
    props: {
        listData: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style lang="sass" scoped>
%checkStyle
	width: 20px
	height: 20px
	border-radius: 50%

.check__item
	display: flex
	padding: 10px
	align-items: center
.checkMark
	display: none
.listText
	margin-left: 30px
	cursor: pointer
	order: 1
	&:hover + .point
		background-color: rgb(170, 170, 170)
.point
	display: block
	position: relative
	background-color: rgb(212, 212, 212)
	cursor: pointer
	transition: background-color .2s ease-in-out
	@extend %checkStyle
	&:hover
		background-color: rgb(170, 170, 170)

input:checked ~ .point::before
	content: ""
	@extend %checkStyle
	background-color: #ffc65b
	position: absolute
	top: 0
	left: 0
	z-index: 10
input:checked ~ .point::after
	content: ""
	width: 8px
	height: 8px
	border-radius: 50%
	background-color: #fff
	position: absolute
	top: 0
	left: 0
	right: 0
	bottom: 0
	margin: auto
	z-index: 11
</style>
